module.exports = __webpack_public_path__ + "static/img/200239.9a405e8e.png";